import React, { createContext, useState } from "react";

export const ChatInputContext = createContext();

export const ChatInputProvider = ({ children }) => {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");//Declare error state to manage error messages
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [fileError, setFileError] = useState("");
  const [isPaperclipVisible, setIsPaperclipVisible] = useState(false); // Paperclip button is hidden by default

  return (
    <ChatInputContext.Provider value={{ 
      message, 
      setMessage, 
      error, 
      setError,
      attachedFiles,
      setAttachedFiles,
      fileError,
      setFileError,
      isPaperclipVisible,
      setIsPaperclipVisible
    }}>
      {children}
    </ChatInputContext.Provider>
  );
};
